import React, { useState, useEffect, useRef } from 'react'
import { Route, Switch, Redirect, useHistory, useLocation } from 'react-router-dom'
import { Layout, Menu, Spin } from 'antd'
// import { FullscreenOutlined } from '@ant-design/icons'
import Welcome from '@/pages/welcome/Welcome'
import { useSelector, useDispatch } from 'react-redux'
import { setMenuStatus } from '@/redux/actions/commonActions'
import PhoneHeader from '@/pages/layout/header/PhoneHeader'
import PhoneRFHeader from './header/PhoneRFHeader'
import { withPermission, isVisibleItem, isVisibleItemStrict, hasVisibleChildren } from '@/annotations/nike-react'
import Cookies from 'js-cookie'
import _ from 'lodash'
// import store from '@/redux'
import { phoneRouterConfigIn, phoneRouterConfigEx } from '@/router/phoneRouter'
import Page404 from '@/components/page404/page404'
import { openFullscreen } from '@/utils/common'
import { consoleFlag } from '@/utils/default'
import '../AndroidDevice/PhoneLayout.less'
import VConsole from 'vconsole'

const { Content } = Layout
let phoneRouterConfig = []
if (window.location.hostname.indexOf('extranet') !== -1) {
  phoneRouterConfig = phoneRouterConfigEx
} else {
  phoneRouterConfig = phoneRouterConfigIn
}
const isRfFun = value => {
  return (value.includes('/rf/') || value.includes('/qr/')) && localStorage.getItem('nfc-auth-type') === '2'
}
const generateRoute = (phoneRouterConfig = []) => {
  return _.flatten(
    phoneRouterConfig.map(config => {
      return _.concat(
        generateRoute(config.children),
        config.component ? (
          <Route
            exact
            key={config.key}
            path={config.key}
            render={() => {
              if (isRfFun(config.key)) return <config.component />
              if (!Cookies.get('nfc-oauth-token')) return <Redirect to={'/login'} />
              return withPermission(config.permission, config.permissionRule)(config.component)()
            }}
          />
        ) : (
          []
        )
      )
    })
  )
}

const PhoneLayout = props => {
  if (consoleFlag) {
    const vConsole = new VConsole()
    console.log(vConsole)
  }
  console.log('location', window.location)
  const spinLoading = useSelector(state => state.loadingStore.loading)
  let languageState = useSelector(state => state.commonStore.language)
  const history = useHistory()
  const dispatch = useDispatch()

  const initMenus = (list, resList) => {
    list.forEach((item, idx) => {
      if (languageState === 'zh_CN') {
        item.label = item.labelZh
      }
      if (languageState === 'en_US') {
        item.label = item.labelEn
      }
      delete item.labelZh
      delete item.labelEn
      if (isVisibleItem(item)) {
        if (hasVisibleChildren(item)) {
          let flattenDeepChild = flattenDeep(item.children)
          // 开始-判断所有子菜单有没有权限，如果一个权限都没有，隐藏此菜单
          let isHidden = false
          for (let index = 0; index < flattenDeepChild.length; index++) {
            const flattenDeepChildItem = flattenDeepChild[index]
            if (isVisibleItemStrict(flattenDeepChildItem)) {
              isHidden = false
              break
            } else {
              isHidden = true
            }
          }
          item.hidden = isHidden
          // 结束
          resList[idx] = _.cloneDeep(item)
          resList[idx].children = []
          return initMenus(item.children, resList[idx].children)
        } else {
          let noChildren = _.cloneDeep(item)
          delete noChildren.children
          delete noChildren.activeMenuKeys
          return (resList[idx] = noChildren)
        }
      }
    })
    return resList
  }
  // 扁平化子菜单
  const flattenDeep = list => {
    let flattened = []
    ;(function flatten(list) {
      list.forEach(item => {
        if (item.children) {
          flatten(item.children)
        }
        flattened.push(item)
      })
    })(list)
    return flattened
  }
  const [openKeys, setOpenKeys] = useState([])
  const [menusList, setMenusList] = useState([])
  const deviceSize = useSelector(state => state.commonStore.deviceSize)
  const [heightSize, setHeightSize] = useState(90)
  const menuLoaction = useLocation()
  useEffect(() => {
    setMenusList(initMenus(_.cloneDeep(phoneRouterConfig), []))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [languageState])
  // store.subscribe(() => {
  //   const state = store.getState()
  //   const language = state.commonStore.language
  //   if (language !== languageState) {
  //     languageState = state.commonStore.language
  //     setMenusList(initMenus(_.cloneDeep(routerConfig), []))
  //   }
  // })
  useEffect(() => {
    setMenusList(initMenus(_.cloneDeep(phoneRouterConfig), []))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    setHeightSize(60 * deviceSize)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deviceSize])
  const initOpenKeys = () => {
    let names = menuLoaction.pathname.split('/').filter(Boolean)
    let resKeys = []
    for (let index = 0; index < names.length; index++) {
      const element = names[index]
      if (index === 0) {
        resKeys.push(`/${element}`)
      } else {
        resKeys.push(`${resKeys[index - 1]}/${element}`)
      }
    }
    return resKeys
  }
  const searchUrlKey = menus => {
    let resKeys = initOpenKeys()
    setOpenKeys(resKeys)
  }
  useEffect(() => {
    searchUrlKey(_.cloneDeep(phoneRouterConfig))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.location])
  const onOpenChange = openKeys => {
    setOpenKeys(openKeys)
  }
  const menuClick = ({ key, keyPath, domEvent }) => {
    dispatch(setMenuStatus(Symbol(false)))
    history.push(key)
  }
  const containerRef = useRef(null)

  return (
    <Layout>
      <Spin spinning={spinLoading} size="large" style={{ top: '50vh', transform: 'translateY(-50%)', zIndex: 10000 }}>
        {isRfFun(menuLoaction.pathname) ? (
          <PhoneRFHeader openFullscreen={openFullscreen} />
        ) : (
          <PhoneHeader
            authenticated={true}
            contentView={
              <Menu
                theme="dark"
                mode="inline"
                openKeys={openKeys}
                onClick={menuClick}
                onOpenChange={onOpenChange}
                items={menusList}
                selectedKeys={[menuLoaction.pathname]}
              ></Menu>
            }
            openFullscreen={openFullscreen}
          ></PhoneHeader>
        )}
        <Layout className="main-layout" style={{ height: `calc(100vh - ${heightSize}px)` }}>
          <Layout className="main-container" id="main-container" ref={containerRef} style={{ marginLeft: 0 }}>
            <Content className="content-layout">
              <div className="content-wrapper">
                <Switch>
                  <Route exact path="/" component={Welcome} />
                  {generateRoute(phoneRouterConfig)}
                  <Route exact path="*" render={Page404} />
                </Switch>
              </div>
            </Content>
          </Layout>
        </Layout>
      </Spin>
    </Layout>
  )
}

export default PhoneLayout
